module.exports = __webpack_public_path__ + "static/media/fuwuneirong@2x.96800ad5.png";